import { ChangeDetectorRef } from '@angular/core';
import { Store } from '@ngrx/store';
import { lastValueFrom } from 'rxjs';
import { RegistrationStatus, RegistrationType } from 'ClientManagementApp/ts/constants';
import { UNKNOWN_ERROR_MESSAGE } from 'RTQApp/features/rtq-shared/constants/constants';
import { ToastMessageType } from 'Angular/features/components/toast-messages/toast-messages.enum';
import { isRegistration, isSerializedSecurityObjectInfo, } from 'ClientManagementApp/ts/types/registration-item.type';
import { PageToastMessagesService } from 'Angular/features/components/toast-messages/page-toast-messages-service';
import { UrlsService } from 'Angular/services/core/urls.service';
import { RegistrationsService } from 'ClientManagementApp/ts/services/registrations.service';
import { RTQAssessmentsFolderableCollectionService } from 'RTQApp/services/rtq-assessments-folderable-collection-ajax.service';
import { RiskToleranceQuestionnaireService } from 'RTQApp/services/rtq-service';
import { BaseAutocompleteComponent } from 'SearchApp/ts/features/base-autocomplete/components/base-autocomplete.component';
import { StartRTQAssessmentModalBaseDirective, StartRTQModalStep } from './start-rtq-assessment-modal-base.directive';
import * as i0 from "@angular/core";
import * as i1 from "RTQApp/services/rtq-assessments-folderable-collection-ajax.service";
import * as i2 from "ClientManagementApp/ts/services/registrations.service";
import * as i3 from "RTQApp/services/rtq-service";
import * as i4 from "@ngrx/store";
import * as i5 from "Angular/features/components/toast-messages/page-toast-messages-service";
import * as i6 from "Angular/services/core/urls.service";
import * as i7 from "../../../../../../../../search/static/search/ts/features/base-autocomplete/components/base-autocomplete.component";
import * as i8 from "@angular/common";
import * as i9 from "@angular/forms";
import * as i10 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i11 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i12 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
import * as i13 from "../../../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
import * as i14 from "RTQApp/apps/rtq-assessment-list-app/components/start-rtq-modal-footer/start-rtq-modal-footer.component";
import * as i15 from "../../../../../../../../sharing/static/sharing/ts/pipes/is-shared-with-others.pipe";
const _c0 = ["clientAutocomplete"];
const _c1 = a0 => ({ "is-invalid": a0 });
const _c2 = () => ({ standalone: true });
const _forTrack0 = ($index, $item) => $item.id;
function StartRTQAssessmentModalComponent_Conditional_3_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8)(1, "p");
    i0.ɵɵtext(2, "You already have an active Assessment for this client. You can either:");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 23)(4, "div")(5, "label", 24)(6, "input", 25);
    i0.ɵɵtwoWayListener("ngModelChange", function StartRTQAssessmentModalComponent_Conditional_3_Template_input_ngModelChange_6_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r2 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r2.resumeExisting, $event) || (ctx_r2.resumeExisting = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(7, "span", 26);
    i0.ɵɵelementStart(8, "span", 27);
    i0.ɵɵtext(9, "Resume existing Questionnaire");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(10, "div")(11, "label", 24)(12, "input", 25);
    i0.ɵɵtwoWayListener("ngModelChange", function StartRTQAssessmentModalComponent_Conditional_3_Template_input_ngModelChange_12_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r2 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r2.resumeExisting, $event) || (ctx_r2.resumeExisting = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(13, "span", 26);
    i0.ɵɵelementStart(14, "span", 27);
    i0.ɵɵtext(15, "Start new Questionnaire");
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelement(16, "div", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("value", true);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r2.resumeExisting);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("value", false);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r2.resumeExisting);
} }
function StartRTQAssessmentModalComponent_Conditional_4_For_4_Conditional_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 31);
} if (rf & 2) {
    i0.ɵɵproperty("name", "icon-team");
} }
function StartRTQAssessmentModalComponent_Conditional_4_For_4_Conditional_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 33);
} if (rf & 2) {
    i0.ɵɵproperty("name", "icon-check");
} }
function StartRTQAssessmentModalComponent_Conditional_4_For_4_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 30);
    i0.ɵɵlistener("click", function StartRTQAssessmentModalComponent_Conditional_4_For_4_Template_tr_click_0_listener() { const questionnaire_r5 = i0.ɵɵrestoreView(_r4).$implicit; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.selectQuestionnaire(questionnaire_r5.id)); });
    i0.ɵɵelementStart(1, "th");
    i0.ɵɵtext(2);
    i0.ɵɵconditionalCreate(3, StartRTQAssessmentModalComponent_Conditional_4_For_4_Conditional_3_Template, 1, 1, ":svg:svg", 31);
    i0.ɵɵpipe(4, "isSharedWithOthers");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td", 32);
    i0.ɵɵconditionalCreate(6, StartRTQAssessmentModalComponent_Conditional_4_For_4_Conditional_6_Template, 1, 1, ":svg:svg", 33);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const questionnaire_r5 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("bg-panel", ctx_r2.isQuestionnaireSelected(questionnaire_r5.id));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", questionnaire_r5.name, " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional(i0.ɵɵpipeBind1(4, 5, questionnaire_r5) ? 3 : -1);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r2.isQuestionnaireSelected(questionnaire_r5.id) ? 6 : -1);
} }
function StartRTQAssessmentModalComponent_Conditional_4_Conditional_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "td", 34);
    i0.ɵɵtext(2, "No questionnaires available.");
    i0.ɵɵelementEnd()();
} }
function StartRTQAssessmentModalComponent_Conditional_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9)(1, "table", 28)(2, "tbody");
    i0.ɵɵrepeaterCreate(3, StartRTQAssessmentModalComponent_Conditional_4_For_4_Template, 7, 7, "tr", 29, _forTrack0);
    i0.ɵɵconditionalCreate(5, StartRTQAssessmentModalComponent_Conditional_4_Conditional_5_Template, 3, 0, "tr");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵrepeater(ctx_r2.questionnaires);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(!(ctx_r2.questionnaires == null ? null : ctx_r2.questionnaires.length) ? 5 : -1);
} }
function StartRTQAssessmentModalComponent_Conditional_20_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13)(1, "div", 14);
    i0.ɵɵtext(2, "Client Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "input", 35, 4);
    i0.ɵɵtwoWayListener("ngModelChange", function StartRTQAssessmentModalComponent_Conditional_20_Template_input_ngModelChange_3_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r2 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r2.model.clientName, $event) || (ctx_r2.model.clientName = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 17);
    i0.ɵɵtext(6, " Please enter a name ");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const clientName_r7 = i0.ɵɵreference(4);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("readOnly", true);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r2.model.clientName);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c1, (clientName_r7.touched || clientName_r7.dirty) && clientName_r7.invalid));
    i0.ɵɵadvance(2);
    i0.ɵɵstyleProp("opacity", (clientName_r7.touched || clientName_r7.dirty) && clientName_r7.invalid ? "1" : "0");
} }
function StartRTQAssessmentModalComponent_ng_template_26_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 36);
    i0.ɵɵlistener("mouseenter", function StartRTQAssessmentModalComponent_ng_template_26_Template_div_mouseenter_0_listener() { const listResults_r9 = i0.ɵɵrestoreView(_r8).$implicit; return i0.ɵɵresetView(listResults_r9.setSelectedIndex(-1)); })("mousedown", function StartRTQAssessmentModalComponent_ng_template_26_Template_div_mousedown_0_listener() { i0.ɵɵrestoreView(_r8); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.startCreateRegistration()); });
    i0.ɵɵelementStart(1, "div", 37);
    i0.ɵɵtext(2, "+ Create new registration for ");
    i0.ɵɵelementStart(3, "strong");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const clientAutocomplete_r10 = i0.ɵɵreference(25);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(clientAutocomplete_r10.inputText);
} }
function StartRTQAssessmentModalComponent_Conditional_28_Conditional_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "input", 42);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("value", ctx_r2.clientEmail)("readOnly", true);
} }
function StartRTQAssessmentModalComponent_Conditional_28_Conditional_14_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 43);
    i0.ɵɵtwoWayListener("ngModelChange", function StartRTQAssessmentModalComponent_Conditional_28_Conditional_14_Template_input_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r12); const ctx_r2 = i0.ɵɵnextContext(2); i0.ɵɵtwoWayBindingSet(ctx_r2.clientEmail, $event) || (ctx_r2.clientEmail = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(1, "div", 17);
    i0.ɵɵtext(2, " Please enter a valid email address ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r2.clientEmail);
    i0.ɵɵproperty("ngModelOptions", i0.ɵɵpureFunction0(5, _c2))("ngClass", i0.ɵɵpureFunction1(6, _c1, ctx_r2.clientEmail && !ctx_r2.isClientEmailValid));
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("opacity", ctx_r2.clientEmail && !ctx_r2.isClientEmailValid ? "1" : "0");
} }
function StartRTQAssessmentModalComponent_Conditional_28_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13)(1, "div", 14);
    i0.ɵɵtext(2, "Client Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 38)(4, "div", 39);
    i0.ɵɵlistener("click", function StartRTQAssessmentModalComponent_Conditional_28_Template_div_click_4_listener() { i0.ɵɵrestoreView(_r11); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.changeClient()); });
    i0.ɵɵelementStart(5, "span");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 40)(8, "span");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(9, "svg", 41);
    i0.ɵɵelementEnd()()()()();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(10, "div", 13)(11, "div", 14);
    i0.ɵɵtext(12, "Email Address");
    i0.ɵɵelementEnd();
    i0.ɵɵconditionalCreate(13, StartRTQAssessmentModalComponent_Conditional_28_Conditional_13_Template, 1, 2, "input", 42)(14, StartRTQAssessmentModalComponent_Conditional_28_Conditional_14_Template, 3, 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(ctx_r2.model.clientName);
    i0.ɵɵadvance();
    i0.ɵɵproperty("tooltipTitle", "Change Client");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "icon-edit");
    i0.ɵɵadvance(4);
    i0.ɵɵconditional(ctx_r2.clientEmailReadOnly ? 13 : 14);
} }
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
function getRegistrationSecurityItemName(registration) {
    if (isRegistration(registration)) {
        return registration.name;
    }
    if (isSerializedSecurityObjectInfo(registration)) {
        return registration.security_name;
    }
    return undefined;
}
export class StartRTQAssessmentModalComponent extends StartRTQAssessmentModalBaseDirective {
    get showClientSearch() {
        return (this.isOnBasicInfoStep &&
            !this.wasOpenedWithRegistration &&
            !this.clientSelected &&
            !this.creatingRegistration);
    }
    get showClientDetails() {
        return (this.isOnBasicInfoStep &&
            !this.wasOpenedWithRegistration &&
            this.clientSelected &&
            !this.creatingRegistration);
    }
    get isCreateRegistrationEmailValid() {
        return EMAIL_REGEX.test(this.createRegistrationEmail.trim());
    }
    get isClientEmailValid() {
        return EMAIL_REGEX.test(this.clientEmail.trim());
    }
    constructor(cd, folderableCollectionService, registrationsService, rtqService, store, toastMessagesService, urlsService) {
        super(cd, folderableCollectionService, rtqService, store, toastMessagesService, urlsService);
        this.registrationsService = registrationsService;
        this.wasOpenedWithRegistration = false;
        this.activeAssessment = null;
        this.resumeExisting = false;
        this.isCheckingActiveAssessment = false;
        this.clientEmail = '';
        this.clientEmailReadOnly = true;
        this.clientSelected = false;
        this.creatingRegistration = false;
        this.createRegistrationName = '';
        this.createRegistrationEmail = '';
        this.isCreatingRegistration = false;
        this.activeAssessmentChecked = false;
    }
    async openModal(registration) {
        this.resetStateForOpen();
        this.modalOpen = true;
        this.fetchQuestionnaires();
        if (!registration) {
            return;
        }
        this.wasOpenedWithRegistration = true;
        this.registrationId = Number(registration.id);
        this.model.clientName = getRegistrationSecurityItemName(registration);
        this.clientSelected = true;
        this.cd.detectChanges();
        await this.checkActiveAssessmentForClient();
    }
    onAutocompleteSubmit(result) {
        this.selectClient(result);
    }
    async submit(isAsync) {
        if (this.isOnActiveAssessmentFoundStep) {
            if (this.resumeExisting && this.activeAssessment) {
                const url = this.urlsService.getUrl(this.urlsService.RTQ.SAVED_ASSESSMENT, {
                    assessmentId: this.activeAssessment.id,
                });
                window.open(url, '_blank');
                this.closeModal();
                return;
            }
            if (this.wasOpenedWithRegistration) {
                this.goToStep(StartRTQModalStep.SELECT_QUESTIONNAIRE);
            }
            else {
                this.goToStep(StartRTQModalStep.BASIC_INFO);
            }
            return;
        }
        if (this.creatingRegistration) {
            await this.createNewRegistration();
            return;
        }
        if (this.isOnBasicInfoStep && !this.wasOpenedWithRegistration && !this.clientSelected) {
            return;
        }
        const emailToSave = !this.clientEmailReadOnly ? this.clientEmail.trim() : undefined;
        await super.submit(isAsync, emailToSave);
    }
    isSubmitDisabled() {
        if (this.creatingRegistration) {
            return (!this.createRegistrationName.trim() ||
                !this.isCreateRegistrationEmailValid ||
                this.isCreatingRegistration);
        }
        if (this.isCheckingActiveAssessment) {
            return true;
        }
        if (super.isSubmitDisabled()) {
            return true;
        }
        if (this.isOnBasicInfoStep && !this.clientSelected) {
            return true;
        }
        if (this.isOnBasicInfoStep && !this.wasOpenedWithRegistration && !this.isClientEmailValid) {
            return true;
        }
        if (this.isOnBasicInfoStep) {
            return !!this.basicInfoForm?.invalid;
        }
        return false;
    }
    cancel() {
        if (this.creatingRegistration) {
            this.cancelCreateRegistration();
            return;
        }
        if (this.isOnActiveAssessmentFoundStep) {
            if (this.wasOpenedWithRegistration) {
                this.closeModal();
            }
            else {
                this.goToStep(StartRTQModalStep.BASIC_INFO);
            }
            return;
        }
        if (!this.wasOpenedWithRegistration) {
            this.clearClientState();
        }
        super.cancel();
    }
    selectClient(result) {
        this.registrationId = typeof result.id === 'string' ? Number(result.id) : result.id;
        this.model.clientName = result.name;
        this.clientSelected = true;
        this.registrationsService.getRegistration(this.registrationId).subscribe({
            next: (registration) => {
                this.clientEmail = registration.contact?.email || '';
                this.clientEmailReadOnly = !!this.clientEmail;
                this.cd.detectChanges();
            },
            error: (error) => {
                this.clientEmail = '';
                this.clientEmailReadOnly = false;
                this.toastMessagesService.addMessage(error?.error?.error || UNKNOWN_ERROR_MESSAGE, ToastMessageType.ERROR);
                this.cd.detectChanges();
            },
        });
        this.checkActiveAssessmentForClient();
        this.cd.detectChanges();
    }
    changeClient() {
        this.clientSelected = false;
        this.registrationId = null;
        this.clientEmail = '';
        this.clientEmailReadOnly = true;
        this.model.clientName = '';
        this.isNewClient = false;
        this.activeAssessmentChecked = false;
        this.activeAssessment = null;
        this.cd.detectChanges();
    }
    startCreateRegistration() {
        this.createRegistrationName = this.clientAutocomplete?.inputText || '';
        this.createRegistrationEmail = '';
        this.creatingRegistration = true;
        if (this.clientAutocomplete) {
            this.clientAutocomplete.reset();
        }
        this.modalHeader = 'Create New Client Registration';
        this.submitButtonText = 'Create';
        this.cd.detectChanges();
    }
    cancelCreateRegistration() {
        this.creatingRegistration = false;
        this.modalHeader = 'Basic Info';
        this.submitButtonText = 'Start';
        this.cd.detectChanges();
    }
    async checkActiveAssessmentForClient() {
        if (this.activeAssessmentChecked || !this.registrationId) {
            return;
        }
        this.isCheckingActiveAssessment = true;
        try {
            const response = await lastValueFrom(this.rtqService.checkActiveAssessmentForRegistration(this.registrationId));
            this.activeAssessmentChecked = true;
            if (response.active_assessment) {
                this.activeAssessment = response.active_assessment;
                this.goToStep(StartRTQModalStep.ACTIVE_ASSESSMENT_FOUND);
            }
        }
        catch (error) {
            this.toastMessagesService.addMessage(error?.error?.error || UNKNOWN_ERROR_MESSAGE, ToastMessageType.ERROR);
        }
        finally {
            this.isCheckingActiveAssessment = false;
            this.cd.detectChanges();
        }
    }
    async createNewRegistration() {
        if (!this.isCreateRegistrationEmailValid || this.isCreatingRegistration) {
            return;
        }
        this.isCreatingRegistration = true;
        const contact = {
            name: this.createRegistrationName.trim(),
            email: this.createRegistrationEmail.trim(),
        };
        try {
            const registration = await lastValueFrom(this.registrationsService.createRegistration({
                name: this.createRegistrationName.trim(),
                registration_type: RegistrationType.CLIENT,
                registration_status: RegistrationStatus.LEAD,
                risk_profile: null,
                contact,
                children: [],
                portfolios: [],
                parent_id: null,
                household_ids: [],
            }));
            this.isNewClient = true;
            this.registrationId = registration.id;
            this.model.clientName = registration.name;
            this.clientEmail = registration.contact?.email || this.createRegistrationEmail.trim();
            this.clientSelected = true;
            this.creatingRegistration = false;
            this.modalHeader = 'Basic Info';
            this.submitButtonText = 'Start';
            this.toastMessagesService.addMessage('Registration successfully created.', ToastMessageType.SUCCESS);
            await this.checkActiveAssessmentForClient();
        }
        catch (error) {
            this.toastMessagesService.addMessage(error?.error?.error || UNKNOWN_ERROR_MESSAGE, ToastMessageType.ERROR);
        }
        finally {
            this.isCreatingRegistration = false;
            this.cd.detectChanges();
        }
    }
    clearClientState() {
        this.clientEmail = '';
        this.clientEmailReadOnly = true;
        this.clientSelected = false;
        this.registrationId = null;
        this.model.clientName = '';
        this.creatingRegistration = false;
        this.createRegistrationName = '';
        this.createRegistrationEmail = '';
        this.isNewClient = false;
        this.isCreatingRegistration = false;
        this.activeAssessmentChecked = false;
        this.activeAssessment = null;
    }
    resetStateForOpen() {
        this.resetBaseState();
        this.wasOpenedWithRegistration = false;
        this.activeAssessment = null;
        this.activeAssessmentChecked = false;
        this.isCheckingActiveAssessment = false;
        this.resumeExisting = false;
        this.clearClientState();
    }
}
StartRTQAssessmentModalComponent.ɵfac = function StartRTQAssessmentModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || StartRTQAssessmentModalComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.RTQAssessmentsFolderableCollectionService), i0.ɵɵdirectiveInject(i2.RegistrationsService), i0.ɵɵdirectiveInject(i3.RiskToleranceQuestionnaireService), i0.ɵɵdirectiveInject(i4.Store), i0.ɵɵdirectiveInject(i5.PageToastMessagesService), i0.ɵɵdirectiveInject(i6.UrlsService)); };
StartRTQAssessmentModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: StartRTQAssessmentModalComponent, selectors: [["ycn-start-rtq-assessment-modal"]], viewQuery: function StartRTQAssessmentModalComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.clientAutocomplete = _t.first);
    } }, standalone: false, features: [i0.ɵɵInheritDefinitionFeature], decls: 38, vars: 36, consts: [["basicInfoForm", "ngForm"], ["clientAutocomplete", ""], ["createRegistrationFooter", ""], ["assessmentName", "ngModel"], ["clientName", "ngModel"], [3, "closeModalHandler", "extraModalClasses", "open"], [3, "closeModalHandler", "header"], [1, "modal-body"], [1, "modal-section"], ["id", "rtqItemTable", 1, "modal-section", 2, "max-height", "420px", "overflow-y", "auto"], [1, "modal-section", 3, "hidden"], [1, "mb-2"], [3, "hidden"], [1, "form-row"], [1, "form-label", "form-label-thin", "pb-1"], ["type", "text", 1, "form-control", 3, "ngModelChange", "ngModel", "readOnly"], ["type", "email", "placeholder", "Enter email address", 1, "form-control", 3, "ngModelChange", "ngModel", "readOnly", "ngClass"], [1, "feedback", "feedback-invalid"], [1, "form-row", 3, "hidden"], [1, "field-input-group", "field-search", "input-group", 3, "submitHandler", "searchType", "buttonType", "placeholder", "listFooterTemplate"], ["required", "", "type", "text", "placeholder", "ex: Risk Assessment", "name", "assessmentName", 1, "form-control", 3, "ngModelChange", "readOnly", "ngModel", "ngClass"], [1, "divider-horizontal"], [3, "cancelHandler", "submitEvent", "asyncCreated", "submitEventLayout", "disableSubmission", "cancelButtonText", "submitButtonText"], [1, "form-row", "custom-controls-stacked"], [1, "custom-control", "custom-radio"], ["type", "radio", "name", "questionnaire-option", 1, "custom-control-input", 3, "ngModelChange", "value", "ngModel"], [1, "custom-control-indicator"], [1, "custom-control-description"], [1, "table", "table-hover", "mb-1"], ["role", "button", 3, "bg-panel"], ["role", "button", 3, "click"], ["ycnIcon", "", "role", "img", 3, "name"], [1, "text-right"], ["ycnIcon", "", "role", "img", 1, "icon-check", "text-blue", "fill-current", 3, "name"], [1, "text-muted"], ["required", "", "type", "text", "placeholder", "ex: John Smith", "name", "clientName", 1, "form-control", 3, "ngModelChange", "readOnly", "ngModel", "ngClass"], [1, "dropdown-item", 3, "mouseenter", "mousedown"], [1, "dropdown-item-text"], [1, "form-group-editable"], [1, "form-value", 3, "click"], ["ycnTooltip", "", 1, "btn", "btn-circle", "btn-transparent", "btn-edit", 3, "tooltipTitle"], ["ycnIcon", "", "role", "img", 1, "icon-edit", 3, "name"], ["type", "email", 1, "form-control", 3, "value", "readOnly"], ["type", "email", "placeholder", "Enter email address", 1, "form-control", 3, "ngModelChange", "ngModel", "ngModelOptions", "ngClass"]], template: function StartRTQAssessmentModalComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "ycn-modal-base", 5);
        i0.ɵɵlistener("closeModalHandler", function StartRTQAssessmentModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.closeModal()); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 6);
        i0.ɵɵlistener("closeModalHandler", function StartRTQAssessmentModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.closeModal()); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 7);
        i0.ɵɵconditionalCreate(3, StartRTQAssessmentModalComponent_Conditional_3_Template, 17, 4, "div", 8);
        i0.ɵɵconditionalCreate(4, StartRTQAssessmentModalComponent_Conditional_4_Template, 6, 1, "div", 9);
        i0.ɵɵelementStart(5, "div", 10)(6, "div", 11)(7, "div", 12)(8, "div", 13)(9, "div", 14);
        i0.ɵɵtext(10, "Name");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "input", 15);
        i0.ɵɵtwoWayListener("ngModelChange", function StartRTQAssessmentModalComponent_Template_input_ngModelChange_11_listener($event) { i0.ɵɵrestoreView(_r1); i0.ɵɵtwoWayBindingSet(ctx.createRegistrationName, $event) || (ctx.createRegistrationName = $event); return i0.ɵɵresetView($event); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(12, "div", 13)(13, "div", 14);
        i0.ɵɵtext(14, "Email");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(15, "input", 16);
        i0.ɵɵtwoWayListener("ngModelChange", function StartRTQAssessmentModalComponent_Template_input_ngModelChange_15_listener($event) { i0.ɵɵrestoreView(_r1); i0.ɵɵtwoWayBindingSet(ctx.createRegistrationEmail, $event) || (ctx.createRegistrationEmail = $event); return i0.ɵɵresetView($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(16, "div", 17);
        i0.ɵɵtext(17, " Please enter a valid email address ");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(18, "form", 12, 0);
        i0.ɵɵconditionalCreate(20, StartRTQAssessmentModalComponent_Conditional_20_Template, 7, 7, "div", 13);
        i0.ɵɵelementStart(21, "div", 18)(22, "div", 14);
        i0.ɵɵtext(23, "Client Name");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(24, "ycn-base-autocomplete", 19, 1);
        i0.ɵɵlistener("submitHandler", function StartRTQAssessmentModalComponent_Template_ycn_base_autocomplete_submitHandler_24_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.onAutocompleteSubmit($event)); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(26, StartRTQAssessmentModalComponent_ng_template_26_Template, 5, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
        i0.ɵɵconditionalCreate(28, StartRTQAssessmentModalComponent_Conditional_28_Template, 15, 4);
        i0.ɵɵelementStart(29, "div", 13)(30, "div", 14);
        i0.ɵɵtext(31, "Assessment Name");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(32, "input", 20, 3);
        i0.ɵɵtwoWayListener("ngModelChange", function StartRTQAssessmentModalComponent_Template_input_ngModelChange_32_listener($event) { i0.ɵɵrestoreView(_r1); i0.ɵɵtwoWayBindingSet(ctx.model.assessmentName, $event) || (ctx.model.assessmentName = $event); return i0.ɵɵresetView($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(34, "div", 17);
        i0.ɵɵtext(35, " Please enter an assessment name ");
        i0.ɵɵelementEnd()()()()();
        i0.ɵɵelement(36, "div", 21);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(37, "ycn-start-rtq-modal-footer", 22);
        i0.ɵɵlistener("cancelHandler", function StartRTQAssessmentModalComponent_Template_ycn_start_rtq_modal_footer_cancelHandler_37_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.cancel()); })("submitEvent", function StartRTQAssessmentModalComponent_Template_ycn_start_rtq_modal_footer_submitEvent_37_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.submit($event)); });
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        const createRegistrationFooter_r13 = i0.ɵɵreference(27);
        const assessmentName_r14 = i0.ɵɵreference(33);
        i0.ɵɵproperty("extraModalClasses", "modal-dialog")("open", ctx.modalOpen);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", ctx.modalHeader);
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(ctx.isOnActiveAssessmentFoundStep ? 3 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.isOnSelectQuestionnaireStep ? 4 : -1);
        i0.ɵɵadvance();
        i0.ɵɵproperty("hidden", !ctx.isOnBasicInfoStep);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("hidden", !ctx.creatingRegistration);
        i0.ɵɵadvance(4);
        i0.ɵɵtwoWayProperty("ngModel", ctx.createRegistrationName);
        i0.ɵɵproperty("readOnly", ctx.isCreatingRegistration);
        i0.ɵɵadvance(4);
        i0.ɵɵtwoWayProperty("ngModel", ctx.createRegistrationEmail);
        i0.ɵɵproperty("readOnly", ctx.isCreatingRegistration)("ngClass", i0.ɵɵpureFunction1(32, _c1, ctx.createRegistrationEmail && !ctx.isCreateRegistrationEmailValid));
        i0.ɵɵadvance();
        i0.ɵɵstyleProp("opacity", ctx.createRegistrationEmail && !ctx.isCreateRegistrationEmailValid ? "1" : "0");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("hidden", ctx.creatingRegistration);
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(ctx.wasOpenedWithRegistration ? 20 : -1);
        i0.ɵɵadvance();
        i0.ɵɵproperty("hidden", !ctx.showClientSearch);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("searchType", "non_household_registrations")("buttonType", "icon-search")("placeholder", "Search for a client...")("listFooterTemplate", createRegistrationFooter_r13);
        i0.ɵɵadvance(4);
        i0.ɵɵconditional(ctx.showClientDetails ? 28 : -1);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("readOnly", ctx.isSubmitting);
        i0.ɵɵtwoWayProperty("ngModel", ctx.model.assessmentName);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(34, _c1, (assessmentName_r14.touched || assessmentName_r14.dirty) && assessmentName_r14.invalid));
        i0.ɵɵadvance(2);
        i0.ɵɵstyleProp("opacity", (assessmentName_r14.touched || assessmentName_r14.dirty) && assessmentName_r14.invalid ? "1" : "0");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("asyncCreated", ctx.asyncCreated)("submitEventLayout", ctx.isOnBasicInfoStep && !ctx.creatingRegistration)("disableSubmission", ctx.isSubmitDisabled())("cancelButtonText", ctx.isOnBasicInfoStep ? "Back" : "Cancel")("submitButtonText", ctx.isSubmitting || ctx.isCreatingRegistration ? "Creating\u2026" : ctx.submitButtonText);
    } }, dependencies: [i7.BaseAutocompleteComponent, i8.NgClass, i9.ɵNgNoValidate, i9.DefaultValueAccessor, i9.RadioControlValueAccessor, i9.NgControlStatus, i9.NgControlStatusGroup, i9.RequiredValidator, i9.NgModel, i9.NgForm, i10.IconDirective, i11.ModalBaseComponent, i12.SimpleModalHeaderComponent, i13.TooltipDirective, i14.StartRTQModalFooterComponent, i15.IsSharedWithOthersPipe], encapsulation: 2 });
